import { useState, useEffect } from 'react';
import useWizardFormCtx from '../../ui/page/wizard/ctx-provider/useWizardFormCtx';
import useRkCtxBo, { useRkCtxAction } from './ctx-provider/useRkCtx';
import WizardFormBo from '../../ui/page/wizard/ctx-provider/WizardFormBo';
import RkConsumer from './RkConsumer';

const useRkSchnelltarifierung = () => {
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const { wizardFormBo } = useWizardFormCtx();

    const rkCtxAction = useRkCtxAction();
    const rkCtxBo = useRkCtxBo();

    useEffect(() => {

        // Abbruch: Unmount
        let cancel = false;

        setLoading(true);
        const wizardFormDto = WizardFormBo.exportFormulardaten(wizardFormBo);

        RkConsumer.rkSchnelltarifierung(wizardFormDto)
            .then(resp => {
                //console.log('update beitrag', !cancel);
                if (cancel) { return; }

                rkCtxBo.paketMitSchutzbrief = resp.paketMitSchutzbrief;
                rkCtxBo.paketOhneSchutzbrief = resp.paketOhneSchutzbrief;
                rkCtxBo.zahlungsweise = resp.zahlungsweise;

                rkCtxAction(rkCtxBo);
                setError(false);
            }).catch(error => {
                if (cancel) { return; }
                setError(true);
            }).finally(() => {
                if (cancel) { return; }
                setLoading(false);
            });

        // Cleanup function that will be called on
        // 1. Unmount
        // 2. Dependency Array Change
        return () => { cancel = true; };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [wizardFormBo]);

    return {
        error,
        loading,
    }
}

export default useRkSchnelltarifierung;

